import React, { useEffect, useRef, useState } from "react";
import { isDefined } from "../../utils/utils";


// Tendina del modulo di recesso e del popup di ricontatto. Non è una <select>: il riquadro delle voci
// di una select lo disegna il sistema operativo e non si può colorare né agganciare alla pillola, quindi
// qui è un elenco nostro, con tastiera e ruoli ARIA di una listbox.
// placeholder si legge nella pillola finché non si sceglie, ma non è fra le voci
const SubmissionListWithdrawalSelect = ({ value, options, placeholder, toggleClassName = '', onChange }) => {
  const [open, setOpen] = useState(false);
  // voce evidenziata dalla tastiera mentre l'elenco è aperto
  const [activeIndex, setActiveIndex] = useState(-1);
  const ref = useRef(null);
  const toggleRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const onMouseDown = (event) => { if (ref.current && !ref.current.contains(event.target)) setOpen(false) };
    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [open]);

  const selectedIndex = options.findIndex((option) => option.value === value);

  const openList = () => {
    setActiveIndex(selectedIndex);
    setOpen(true);
  };

  const select = (option) => {
    onChange(option.value);
    setOpen(false);
  };

  const onToggleClick = () => {
    // Safari non dà il fuoco a un pulsante cliccato: senza, il bordo azzurro e la tastiera non seguirebbero
    toggleRef.current.focus();
    open ? setOpen(false) : openList();
  };

  const onKeyDown = (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!open) return openList();

      const step = event.key === 'ArrowDown' ? 1 : -1;
      setActiveIndex(Math.min(Math.max(activeIndex + step, 0), options.length - 1));
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (!open) return openList();

      if (options[activeIndex]) select(options[activeIndex]);
      else setOpen(false);
    } else if (event.key === 'Escape' && open) {
      // chiude solo l'elenco: nel popup lo stesso tasto, ascoltato sul document, chiuderebbe anche quello
      event.nativeEvent.stopImmediatePropagation();
      setOpen(false);
    } else if (event.key === 'Tab') {
      setOpen(false);
    }
  };

  return <div className={`slx-select ${open ? 'slx-select--open' : ''}`} ref={ref}>
    <button
      type="button"
      ref={toggleRef}
      className={`slx-select__toggle ${toggleClassName} ${isDefined(value) ? '' : 'slx-form__control--placeholder'}`}
      aria-haspopup="listbox"
      aria-expanded={open}
      onClick={onToggleClick}
      onKeyDown={onKeyDown}
    >
      {selectedIndex >= 0 ? options[selectedIndex].label : placeholder}
    </button>

    {
      open &&
        <div className="slx-select__list">
          <ul className="slx-select__options" role="listbox">
            {
              options.map((option, index) =>
                <li
                  key={option.value}
                  role="option"
                  aria-selected={option.value === value}
                  className={`slx-select__option ${option.value === value ? 'slx-select__option--selected' : ''} ${index === activeIndex ? 'slx-select__option--active' : ''}`}
                  onMouseEnter={() => setActiveIndex(index)}
                  onClick={() => select(option)}
                >
                  {option.label}
                </li>
              )
            }
          </ul>
        </div>
    }
  </div>
};

export default SubmissionListWithdrawalSelect;
